import gql from 'graphql-tag';

export default gql`
  mutation AUTH_PASSWORD_RESET_EMAIL($slug: String!, $subpropertySiteName: String!) {
    inscriptionSendWelcomeParentEmail(slug: $slug, subpropertySiteName: $subpropertySiteName)
  }
`
